import { VIN_CRM_API_BASE_URL } from "@/Config/apiServices";
import axios from "axios";

interface FormData {
  name: string;
  email: string;
  phone: string;
  course: string;
  mode: string;
  qualification: string;
  City?: any;
  country?: any;
  utm_id?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  page_url?: string;
  is_otp_verified: number;
}

export const submitFormData = async (data: FormData) => {
  const crmCountryCode = data?.phone?.startsWith("+234")
    ? "NIGERIA"
    : data.phone.startsWith("+254")
    ? "KENYA"
    : data.phone.startsWith("+27")
    ? "SOUTH AFRICA"
    : data.phone.startsWith("+256")
    ? "UGANDA"
    : data.phone.startsWith("+255")
    ? "TANZANIA"
    : null;
  const leadsData = {
    Name: data?.name,
    Email: data?.email,
    Phone: data?.phone,
    Course: data?.course,
    Mode_of_Study: data.mode,
    Qualification: data?.qualification,
    Programme_Of_Interest: data?.course,
    Interested_Topic: data?.course,
    page_url: data?.page_url,
    City: data?.City || "",
    country: crmCountryCode ? crmCountryCode : data?.country || "",
    is_otp_verified: data?.is_otp_verified,
  };

  let vinCrmData = null;
  if (crmCountryCode) {
    vinCrmData = {
      domain: "crm",
      type: "add_lead_to_crm",
      name: data.name,
      email: data.email,
      study_mode: data.mode,
      mobile: data.phone,
      interest: data.course,
      highest_qualification: data.qualification,
      country: crmCountryCode,
      city: data.City || "",
      source: "SA Website",
      campaign: data.utm_campaign,
      utm_source: data.utm_source || "SA Website",
      utm_campaign: data.utm_campaign,
      utm_id: data.utm_id,
      utm_url: data.page_url,
      utm_medium: data.utm_medium,
      utm_term: data.utm_term,
      utm_content: data.utm_content,
      utm_referrer: data.page_url,
      is_otp_verified: data?.is_otp_verified,
    };
  }

  if (leadsData?.Email || vinCrmData?.email) {
    try {
      const cmsApiUrl = VIN_CRM_API_BASE_URL;
      const leadsApiUrl = process.env.LEADS_API_BASE_URL;

      if (!leadsApiUrl) {
        throw new Error(
          "Leads API base URL is not defined in the environment variables"
        );
      }

      await axios.post(leadsApiUrl, leadsData);

      if (vinCrmData) {
        if (!cmsApiUrl) {
          throw new Error(
            "VinCRM API base URL is not defined in the environment variables"
          );
        }
        await axios.post(cmsApiUrl, vinCrmData);
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error("Error submitting lead data:", error.message);
      } else {
        console.error("An unexpected error occurred:", error);
      }
      throw error;
    }
  }
};
